import moment from 'moment';

export function formatedDate(date, format, isUnix = false) {
    return isUnix ? moment.unix(date).format(format).toString() : moment(date).format(format).toString();
}